import React, { useState, useEffect, useContext } from "react";
import PartnerDepartmentReadOnlyRow from "./PartnerDepartmentReadOnlyRow";
import PartnerDepartmentTableRow from "./PartnerDepartmentTableRow";
import UserPartnerDD from "./UserPartnerDD";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";


function PartnerDepartmentTable({ key, setPartnerDepartment, loginId, companyId, userPartnerList, setSupplierId, supplierId }) {
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isPartnerDepartmentLoading, setIsPartnerDepartmentLoading] = useState(false);
	const [partnerDepartments, setPartnerDepartments] = useState([]);
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		partnerKey: supplierId,
		departmentKey: 0,
		partnerKey: 0,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		if (supplierId > 0) {
			initialValues.partnerKey = supplierId;
			setFormValues({ ...formValues, ["partnerKey"]: supplierId });
			removeRowTable();
			setPartnerDepartments([]);
			setIsPartnerDepartmentLoading(false);
			fetchPartnerDepartments();
		}
	}, [supplierId]);

	const handleClose = (event) => {
		setPartnerDepartment(false);
	};

	function fetchPartnerDepartments() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0
			|| !initialValues.loginId || !supplierId || supplierId === 0) {
			return;
		}
		resetCounter();
		setIsPartnerDepartmentLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, companyId: initialValues.companyId,
				loginId: initialValues.loginId, partnerKey: supplierId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserPartnerDepartment", "/Service/PartnerSubsService/GetUserPartnerDepartment", requestOptions, retrievePartnerDepartmentSuccess, retrievePartnerDepartmentFail);
		} catch (error) {
			setIsPartnerDepartmentLoading(false);
			throw new Error(error.message);
		}
	}

	function retrievePartnerDepartmentFail(redirect) {
		setIsPartnerDepartmentLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.partnerGetDepartmentFailed"));
	}

	function retrievePartnerDepartmentSuccess(responseData) {
		let fetchUserPartnerDepartmentsResponse;
		if (responseData) {
			fetchUserPartnerDepartmentsResponse = responseData.fetchUserPartnerDepartmentsResponse;
			if (fetchUserPartnerDepartmentsResponse && fetchUserPartnerDepartmentsResponse.errorCode === "0") {
				setPartnerDepartments(fetchUserPartnerDepartmentsResponse.departments.slice())
			} else if (fetchUserPartnerDepartmentsResponse && fetchUserPartnerDepartmentsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserPartnerDepartmentsResponse) {
				setError(t("error.error") + " " + fetchUserPartnerDepartmentsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsPartnerDepartmentLoading(false);
	}
	const handleDeleteClick = (event, partnerDeptItem, completeCallback) => {
		event.preventDefault();
		deletePartnerDepartment(partnerDeptItem, completeCallback);
	};
	const deletePartnerDepartment = (partnerDeptItem, completeCallback) => {
		let action = 3;
		if (partnerDeptItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: formValues.loginId,
			departmentKey: partnerDeptItem.departmentKey,
			partnerKey: partnerDeptItem.partnerKey,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserPartnerDepartment", "/Service/PartnerSubsService/DeleteUserPartnerDepartment", requestOptions, deletePartnerDepartmentSuccess, deletePartnerDepartmentFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deletePartnerDepartmentFail(redirect, completeCallback) {
		setError(t("error.userDeptEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deletePartnerDepartmentSuccess(responseData, completeCallback) {
		let deleteUserPartnerDepartmentResponse;
		if (responseData) {
			deleteUserPartnerDepartmentResponse = responseData.deleteUserPartnerDepartmentResponse;
			if (deleteUserPartnerDepartmentResponse) {
				if (deleteUserPartnerDepartmentResponse.errorCode === "0") {
					resetRowTable();
					refreshPartnerDepartment();
				} else {
					setError(t("error.error") + " " +
						deleteUserPartnerDepartmentResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};

	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (partnerDepartments.length > 0) {
				partnerDepartments.map((partnerDeptItem, index) => {
					if (partnerDeptItem.departmentKey === setValues.departmentKey && partnerDeptItem.partnerKey === setValues.partnerKey) {
						setError(t("error.userDeptDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				savePartnerDepartment(action, setValues, completeCallback);
			}
		}
	};
	const savePartnerDepartment = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			departmentKey: setValues.departmentKey,
			partnerKey: setValues.partnerKey,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserPartnerDepartment", "/Service/PartnerSubsService/AddUpdateUserPartnerDepartment", requestOptions, savePartnerDepartmentSuccess, savePartnerDepartmentFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function savePartnerDepartmentFail(redirect, completeCallback) {
		setError(t("error.userDeptEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function savePartnerDepartmentSuccess(responseData, completeCallback) {
		let addUpdateUserPartnerDepartmentResponse;
		if (responseData) {
			addUpdateUserPartnerDepartmentResponse = responseData.addUpdateUserPartnerDepartmentResponse;
			if (addUpdateUserPartnerDepartmentResponse) {
				if (addUpdateUserPartnerDepartmentResponse.errorCode === "0") {
					resetRowTable();
					refreshPartnerDepartment();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserPartnerDepartmentResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshPartnerDepartment() {
		fetchPartnerDepartments();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isPartnerDepartmentLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<UserPartnerDD loginId={loginId} companyId={companyId} setSupplierId={setSupplierId} userPartnerList={userPartnerList} 
							supplierId = {supplierId} />
						</div>
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					{(supplierId > 0) ?
						<div className="row">
							<div className="col">
								<table className="list-table" role="table">
									<thead>
										<tr role="row">
											<th className="list-th">{t("page.dept.name")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th">
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</thead>
									<tbody role="rowgroup">
										{add && addRowTop &&
											<PartnerDepartmentTableRow
												index={count}
												partnerKey={supplierId}
												handleSubmit={handleSubmit}
												setError={setError}
												t={t}
												setAdd={setAdd}
												oddIdx={((partnerDepartments.length % 2) > 0) ? true : false} />
										}
										{(partnerDepartments.length > 0) ? (
											partnerDepartments.map((partnerDeptItem, index) => (
												<PartnerDepartmentReadOnlyRow
													index={count}
													t={t}
													partnerDeptItem={partnerDeptItem}
													handleDeleteClick={handleDeleteClick}
													oddIdx={((index % 2) > 0) ? true : false}
													setError={setError}
												/>
											))
										) : (<></>)}
										{add && addRowBottom &&
											<PartnerDepartmentTableRow
												index={count}
												partnerKey={supplierId}
												handleSubmit={handleSubmit}
												setError={setError}
												t={t}
												setAdd={setAdd}
												oddIdx={((partnerDepartments.length % 2) > 0) ? true : false} />
										}
									</tbody>
									{(partnerDepartments.length > 10) ? (<tfoot>
										<tr role="row">
											<th className="list-th">{t("page.dept.name")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th">
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</tfoot>
									) : (<></>)}
								</table>
								<div className="row">
									<div className="col mt-3">
										{(error) ? (
											<div id="inerrorMessage1" className="errorblock">
												{error}
											</div>
										) : (<></>)}
									</div>
								</div>
								<div className="footer">
									<input
										type="button"
										name="edit-part-dept-close"
										id="edit-part-dept-close"
										className="btn btn-secondary btn-block" data-dismiss="modal"
										onClick={(e) => handleClose(e)}
										style={{ marginTop: "10px", marginBottom: "10px" }}
										value={closeText}
									></input>
								</div>
							</div>
						</div> :
						(!userPartnerList || userPartnerList.length === 0) ?
							<>
								<div className="row">
									<div className="col mt-3">
										<div id="inerrorMessage1" className="errorblock">
											{t("error.partnerReqd")}
										</div>
									</div>
								</div>
								<div className="footer">
									<input
										type="button"
										name="edit-part-dept-close"
										id="edit-part-dept-close"
										className="btn btn-secondary btn-block" data-dismiss="modal"
										onClick={(e) => handleClose(e)}
										style={{ marginTop: "10px", marginBottom: "10px" }}
										value={closeText}
									></input>
								</div>
							</> : (<></>)}
				</div>
				: null}
		</>
	);
}
export default PartnerDepartmentTable;